<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="id"
        v-slot="{ validated, valid, errors }"
        slim
    >
        <rkm-form-group
            :invalid-feedback="errors[0]"
            :label-for="id"
            :state="rules ? (validated ? valid : null) : null"
        >

            <template v-if="label">
                <div class="float-left">
                    <label :for="id">
                        {{ label + (rules && rules.required ? ' *' : '') }}
                    </label>
                </div>

                <slot name="label-right" />
            </template>

            <b-input-group>
                <b-form-input
                    ref="BaseTimeInput"
                    :disabled="disabled"
                    :id="id"
                    :readonly="readonly"
                    :state="rules ? (validated ? valid : null) : null"
                    :value="value"
                    @blur="handleBlur"
                    type="text"
                    :placeholder="`HH:MM${showSeconds ? ':SS' : ''}`"
                    v-mask="'##:##' + (showSeconds ? ':##' : '')"
                />

                <b-input-group-append>
                    <b-form-timepicker
                        :disabled="disabled"
                        :readonly="readonly"
                        :right="right"
                        :show-seconds="showSeconds"
                        :state="rules ? (validated ? valid : null) : null"
                        :value="value"
                        @input="$emit('input', $event)"
                        @hidden="$emit('hidden', $event)"
                        button-only
                        hide-header
                        hourCycle="h23"
                        label-close-button="Fechar"
                        label-decrement="Decrementar"
                        label-hours="Horas"
                        label-increment="Incrementar"
                        label-minutes="Minutos"
                        label-no-time-selected="Nenhum horário selecionado"
                        label-now-button="Selecionar agora"
                        label-reset-button="Resetar"
                        label-seconds="Segundos"
                        locale="pt-BR"
                        menu-class="rkm-time-picker"
                        no-close-button
                    />
                </b-input-group-append>
            </b-input-group>
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
import { BInputGroup, BFormInput, BInputGroupAppend, BFormTimepicker } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate';
import Cleave from 'cleave.js'

export default {
    components: { BInputGroup, BFormInput, BInputGroupAppend, BFormTimepicker, ValidationProvider },
    computed: {
        id() {

            // TODO: Centralizar e a tratar melhor a string, removendo caracteres especiais, acentos, etc.
            const id = (this.label || this.name || 'unknown')
                .toLowerCase()
                .replace(/[()\\/\-<>]/gi, '')
                .replace(/[\s]/gi, '-')

            return this.uniqueId(id)
        },
        rules() {

            return this.disabled ? null : this.validations
        }
    },
    methods: {
        handleBlur() {

            let el = this.$refs.BaseTimeInput.$el
            let time = el.value

            if ((this.showSeconds && el.value.length !== 8)
                || (!this.showSeconds && el.value.length !== 5)
            ) {

                time = el.value = null
            }

            else if (!this.showSeconds) {

                time += ':00'
            }

            this.$emit('blur', time)
            this.$emit('input', time)
        },
    },
    props: {
        disabled: { type: Boolean },
        label: { type: [String, Boolean], default: '' },
        name: { type: String },
        readonly: { type: Boolean },
        right: { type: Boolean },
        showSeconds: { type: Boolean, default: false },
        validationMode: { type: String, default: 'aggressive' },
        validations: { type: Object },
        value: { type: String, default: '' },
    },
    mounted() {

        new Cleave(this.$refs.BaseTimeInput.$el, {
            time: true,
            timePattern: (this.showSeconds ? ['h', 'm', 's'] : ['h', 'm'])
        })
    }
}
</script>

<style scoped>
.dropdown-menu.dropdown-menu-right {
    left: auto !important;
}
</style>